import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from '../ui';

import StepsWrapper from './Steps.style';
import {
  decreaseStepByOne,
  cleanQuotationError
} from "../../actions";

const showBackButton = (isLoading, show = true) => {
  return !isLoading && show;
};

class Steps extends Component {

  getStepText(stepIndex) {
    const { globalSteps } = this.props;
    return globalSteps[stepIndex] || '';
  }

  render() {
    const globals = [];
    let select = true;
    const { globalSteps, selectedStep, stepInnerPage, isLoading, onBackClick } = this.props;
    const { length } = globalSteps;
    const backButton = stepInnerPage.name !== '' ? stepInnerPage.backButton : selectedStep.backButton;
    const stepPadClass = showBackButton(isLoading, backButton) ? ("Steps-padTop-4") : "";

    for (let i = 0; i < length; i++) {
      globals.push(
        <div key={i} className="Steps-step">
          <Step selected={select} withLine={i > 0}
            stepText={this.getStepText(i)} />
        </div>
      );
      if (select && i === selectedStep.global) select = false;
    }

    return (
      <StepsWrapper>
        {showBackButton(isLoading, backButton) &&
          <Button plain onClick={onBackClick} className="Steps-backButton">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            <span>Volver</span>
          </Button>
        }
        {selectedStep.global >= 0 && (
          <div className={`Steps ${stepPadClass}`}>
            {globals}
          </div>
        )}
      </StepsWrapper>
    );
  }
}

const Step = ({ selected, stepText, withLine }) => {
  const stateClass = selected ? "Steps-step-on" : "Steps-step-off";

  return (
    <div className="Steps-step">
      {withLine ? (<Line stateClass={stateClass} />) : null}

      <Circle stateClass={stateClass} />

      <div className={`Steps-step-text ${selected ? 'Steps-step-text-on' : ''}`}>
        {stepText}
      </div>
    </div>
  )
};

const Circle = ({ stateClass }) => {
  return (<div className={`Steps-circle ${stateClass}`} />)
};

const Line = ({ stateClass }) => {
  return (<div className={`Steps-line ${stateClass}`} />)
};

const mapStateToProps = (state, ownProps) => {
  return {
    steps: state.steps.steps,
    selectedStep: state.steps.selectedStep,
    stepInnerPage: state.steps.stepInnerPage,
    isLoading: state.steps.isLoading,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onBackClick: () => {
      dispatch(decreaseStepByOne());
      dispatch(cleanQuotationError());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Steps);
